module.exports = __webpack_public_path__ + "static/media/img22.f194cced.jpg";